import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}
export function Toggle({
  checked,
  onChange,
  label,
  description,
  disabled
}: ToggleProps) {
  return <div className="flex min-h-[44px] items-center justify-between gap-4 py-2.5" data-id="element-73" data-mp="qnff25p1u2xa">
      <span className="flex flex-col" data-id="element-74" data-mp="mn4yjz3mru46">
        <span className="text-sm font-medium text-ink" data-id="element-75" data-mp="1jbtempvsd7ay">{label}</span>
        {description && <span className="mt-0.5 text-xs leading-relaxed text-muted" data-id="element-76" data-mp="1jdxduuiqpi4w">{description}</span>}
      </span>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} disabled={disabled} onClick={() => onChange(!checked)} className={`relative h-7 w-12 shrink-0 rounded-full transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral disabled:opacity-40 ${checked ? 'bg-coral' : 'bg-line'}`} data-id="element-77" data-mp="1eet5u77jxqg5">
        <span className={`absolute top-1 h-5 w-5 rounded-full bg-surface transition-transform duration-150 ease-calm ${checked ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-78" data-mp="3w019ckwxtfok" />
      </button>
    </div>;
}